/**
 * =============================================================================
 * Application Entry Point
 * =============================================================================
 *
 * Main entry point for the RehaPiano Admin Portal frontend.
 *
 * Responsibilities:
 * - Initialize React application
 * - Set up providers (React Query, Router, Auth)
 * - Render root component
 */

import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'

import App from './App'
import { AuthProvider } from './auth/AuthProvider'
import './index.css'

// =============================================================================
// React Query Configuration
// =============================================================================

/**
 * React Query client with default options.
 * - staleTime: Data considered fresh for 5 minutes
 * - retry: Retry failed requests once
 */
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      retry: 1,
    },
  },
})

// =============================================================================
// Application Render
// =============================================================================

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <App />
        </AuthProvider>
      </QueryClientProvider>
    </BrowserRouter>
  </React.StrictMode>,
)
